import { createFileRoute } from "@tanstack/react-router";

import { CoachProductAutomationCreatePage } from "src/pages/CoachProductAutomationCreatePage";

export const Route = createFileRoute(
  "/_auth/_coach/products/$productId/automations/new",
)({
  component: CoachProductAutomationCreatePage,
  ssr: true,
  staticData: {
    getBreadcrumb({ i18n, params }) {
      return {
        label: i18n.t("automationBuilder.createTitle"),
        href: `/products/${params.productId}/automations/new`,
      };
    },
  },
});
